import api from '@/helpers/api'

const API_READ = `/api/client/entities`

export default {
    namespaced: true,
    state: {
        status: '',
        entities: [],
        errMessage: '',
    },
    mutations: {
        request(state) {
            state.status = "Loading"
        },
        success(state) {
            state.status = "Success"
        },
        error(state, {message}) {
            state.status = "Error",
            state.errMessage = message
        },
        read(state, {entities}) {
            state.entities = [...entities]
        }
    },
    actions: {
        read({commit}) {
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('get', API_READ, {})
                    .then((result) => {
                        // console.log(result);
                        commit('success');
                        commit('read', { entities: result.data.data });

                        return resolve(result);
                    }).catch((err) => {
                        commit('error', { message: err });
                        return reject(err);
                    });
            });
        }
    },
    getters: {
        entities: () =>(state) => state.entities,
    }
}